import {
  usePersistedSessionState,
  useRouter,
  useShoppingType,
} from '@edreamsodigeo/frontend-core';

import { ShoppingType } from 'generated/graphql';

const bookingIdRegex = new RegExp('/(\\d{10,12})/');
const basketIdRegex = new RegExp(
  '/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})/'
);

export const useBookingIdFromUrl = (): string => {
  const { query, pathname } = useRouter();

  const matchingBookingId = pathname.match(bookingIdRegex);
  const bookingId = matchingBookingId ? matchingBookingId[1] : '0';

  return (query?.bookingId as string) || bookingId;
};

const useBasketIdFromUrl = (): string => {
  const { query, pathname } = useRouter();

  const matchingBasketIds = pathname.match(basketIdRegex);
  const basketId = matchingBasketIds ? matchingBasketIds[1] : '';

  return (query?.shoppingId as string) || basketId;
};

const useBookingId = (): number => {
  const bookingIdFromUrl = useBookingIdFromUrl();
  const [bookingIdFromSession] = usePersistedSessionState('bookingId');
  return bookingIdFromUrl || bookingIdFromSession || '';
};

const useShoppingInfoWithCart = (): ShoppingInfo => ({
  shoppingId: `${useBookingId()}`,
  shoppingType: ShoppingType.Cart,
});

const useShoppingInfoWithBasket = (): ShoppingInfo => ({
  shoppingId: useBasketIdFromUrl(),
  shoppingType: ShoppingType.BasketV3,
});

interface ShoppingInfo {
  shoppingId: string;
  shoppingType: ShoppingType;
}
export const useShoppingInfo = (): ShoppingInfo => {
  const shoppingType = useShoppingType();
  const shoppingInfoWithShoppingCart = useShoppingInfoWithCart();
  const shoppingInfoWithShoppingBasket = useShoppingInfoWithBasket();
  return shoppingType === 'CART'
    ? shoppingInfoWithShoppingCart
    : shoppingInfoWithShoppingBasket;
};
